<script setup lang="ts">
import Statistics from "@/views/playground/planner/business-management/statistics/Statistics.vue";
</script>

<template>
  <statistics></statistics>
</template>

<style scoped></style>
